import script from "./CustomQuotesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomQuotesTable.vue?vue&type=script&setup=true&lang=js"

import "./CustomQuotesTable.vue?vue&type=style&index=0&id=5da5ebc7&lang=scss"

const __exports__ = script;

export default __exports__